import config from 'config'

const resourceName = 'banking/bookkeepingaccountingrecords'
const urls = {
  listSetting: `${config.resourceHost}setting/userlist/booking`,
  bookingList: `${config.resourceHost}${resourceName}`,
}

export default {
  resourceUrl: `${config.resourceHost}${resourceName}`,
  bookingListSetting: `${config.resourceHost}setting/userlist/booking`,
  urls,

  options: {
    list: {
      name: resourceName,
    },
  },
}
